import { useLanguage } from '@/contexts/LanguageContext';
import { UTILITY_OPTIONS } from '@/lib/utilities';

export default function UtilityCheckboxes({ category, selected = [], onChange, compact = false }) {
  const { language } = useLanguage();
  const options = UTILITY_OPTIONS[category] || [];

  const toggle = (val) => {
    if (selected.includes(val)) {
      onChange(selected.filter(v => v !== val));
    } else {
      onChange([...selected, val]);
    }
  };

  return (
    <div className={`flex flex-wrap gap-2 ${compact ? '' : 'mt-1'}`}>
      {options.map(opt => {
        const active = selected.includes(opt.value);
        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => toggle(opt.value)}
            className={`px-3 py-1.5 rounded-full text-xs font-medium border transition-colors ${
              active
                ? 'bg-primary/10 border-primary text-primary'
                : 'bg-slate-50 border-slate-200 text-slate-600 hover:border-slate-300'
            }`}
            data-testid={`utility-${category}-${opt.value}`}
          >
            {opt[language]}
          </button>
        );
      })}
    </div>
  );
}
